module.exports = __webpack_public_path__ + "static/media/Seagul.c1d568bd.mp3";